

module.exports = {
    PIEZO_IMPORT_TYPE: {
        ADES_PIEZO: 'ADES_PIEZO',
        EMPTY: 'EMPTY',
    },
    JOB_TYPES: {
        ADES_QUALITO: 'wsAdesQualito',
        ADES_PIEZO: 'wsAdesPiezo',
        NAIADES: 'surfaceQualitometer',
        HYDRO: 'hydro',
        SYNOP: 'synop',
        OROBNAT: 'tapWater',
        ERA5: 'era5',
    },
}